import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";

const useAnnotationPost = () => {
  const getRequestUrl = (annotation) => {
    if (annotation.id) {
      return `${MONOLITH_ORIGIN}/api/v2/annotation/${annotation.id}/`;
    }
    return `${MONOLITH_ORIGIN}/api/v2/annotation/`;
  };

  const createPostRequest = (annotation) => {
    const requestUrl = getRequestUrl(annotation);

    return new Request(requestUrl, {
      method: "POST",
      body: JSON.stringify(annotation),
      headers: { "Content-Type": "application/json" },
    });
  };

  return useRestMutation(createPostRequest);
};

export default useAnnotationPost;
